export const SET_MENUS_DATA = "SET_MENUS_DATA";